import angular from 'angular'
import chosenDirective from './chosenDirective'

export default angular
    .module('app.chosen', [])
    .directive('chosen', ['$timeout', chosenDirective])
    .name



// WEBPACK FOOTER //
// ./src/components/chosen/index.js